import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Icon from './Icon';
import Title from './Title';
import { palette } from '../../constants/styles';

const tools = [
  {
    name: 'metas',
    customName: 'Metas',
    icon: 'metasTool',
  },
  {
    name: 'retiro',
    customName: 'Retiro',
    icon: 'retiroTool',
  },
  {
    name: 'ahorro',
    customName: 'Ahorro',
    icon: 'ahorroTool',
  },
  {
    name: 'deuda',
    customName: 'Deuda',
    icon: 'deudaTool',
  },
];

const StyledTool = styled(Link)`
  text-decoration: none;
  padding: 10px 15px;
  border-radius: 8px;

  &:hover {
    background-color: ${palette.sweetGray};
  }
`;

const Tools = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;

  ${({ styles }) => styles}
`;

const ToolsSubset = ({ currentTool, styles }) => (
  <Tools styles={styles}>
    {tools.map(tool => (tool.name !== currentTool
    && (
      <StyledTool key={`${currentTool}-${tool.name}`} to={`/${tool.name}`}>
        <Icon icon={tool.icon} size={50} />
        <Title level={6}>
          {tool.customName}
        </Title>
      </StyledTool>
    )))}
  </Tools>
);

ToolsSubset.propTypes = {
  currentTool: PropTypes.string,
  styles: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

ToolsSubset.defaultProps = {
  currentTool: '',
  styles: {},
};


export default ToolsSubset;